<template>
    <li>
        <slot
            v-bind:is-active="isActive" 
            v-bind:link-events="linkEvents"
            v-bind:toggle-events="toggleEvents"
            v-bind:sub-menu-props="subMenuProps">
        </slot>
    </li>
</template>

<script>
export default {
    name: 'MainMenuItem',
    inject: ['mainMenuSharedState'],
    props: ['alias', 'hasSubMenu'],
    data() {
        let self = this;
        return {
            linkEvents: {
                mouseover() {
                    if (!self.isMobile && !self.isActive) {
                        self.openMenu();
                    }
                }
            },
            toggleEvents: {
                click(e) {
                    if (self.isMobile) {
                        e.preventDefault();
                        e.stopPropagation();
                        if(!self.isActive) {
                            self.openMenu();
                        } else {
                            self.closeMenu();
                        }
                    }
                }
            }
        }
    },
    computed: {
        subMenuProps() {
            let self = this;
            return {
                class: { 'hidden' : !self.isActive }
            }
        },
        isMobile() {
            return this.mainMenuSharedState.isMobile;
        },
        isActive() {
            return this.mainMenuSharedState.activeMenuItem == this.alias;
        }
    },
    methods: {
        openMenu() {
            this.mainMenuSharedState.activeMenuItem = this.alias;
        },
        closeMenu() {
            this.mainMenuSharedState.activeMenuItem = null;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/js/components/MainMenuItem.vue